import { TreeSelect } from "antd";
import { useEffect, useState } from "react";
import { StateCrudApi } from "../../../client/EntityApi";

const StateTreeSelect = (props: any) => {
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    setLoading(true);
    StateCrudApi.getAll(false)
      .then((response) =>
        setOptions(response["hydra:member"].filter((item: any) => !item.parent))
      )
      .finally(() => setLoading(false));
  }, []);

  return (
    <TreeSelect
      {...props}
      treeLine
      treeDefaultExpandAll
      loading={loading}
      treeData={options}
      placeholder="Durum seçiniz"
      dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
    />
  );
};

export default StateTreeSelect;
